import { ArticleList as _ArticleList } from './articlelist'
import { Details as _Details } from './details'
import { Main as _Main } from './main'
import { SearchResults as _SearchResults } from './searchresults'

export const AnswersMain = _Main
export const ArticleList = _ArticleList
export const Details = _Details
export const SearchResults = _SearchResults
